<template>
  <div class="user-edit-wrapper">
    <el-form
      :loading="submiting"
      :model="userForm"
      :rules="formRules"
      label-position="top"
      status-icon
      ref="userForm"
      class="user-form"
    >
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item label="设置类型:" prop="mode">
            <el-radio-group v-model="userForm.mode">
              <el-radio label="ADD">增加</el-radio>
              <el-radio label="MINUS">移除</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="用户:" prop="userIds">
            <el-checkbox-group v-model="userForm.userIds">
              <el-checkbox v-for="user in userOptions" :label="user.id" :key="user.id" class="checkbox">{{user.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col :span="24">
            <div class="user-control">
              <el-input
                style="width:200px;margin-right: 10px"
                v-model="userName"
                size="small"
                clearable
                placeholder="输入用户姓名搜索"
              ></el-input>
              <el-pagination
                style="line-height: 0;"
                small
                layout="prev, pager, next"
                :page-size="size"
                :current-page="page+1"
                @current-change="handleCurrentChange"
                :total="totalSizes"
              ></el-pagination>
            </div>
        </el-col>

        <el-col :span="24">
          <el-form-item label="角色:" prop="roles">
            <el-checkbox-group v-model="userForm.roles">
              <el-checkbox
                class="checkbox"
                v-for="role in rolesOptions"
                :label="role.id"
                :key="role.id"
              >{{role.name}}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item style="text-align:right">
        <el-button type="primary" size="small" @click="onSubmit('userForm')">提交变更</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      submiting: false,
      userName: "",
      userForm: {
        mode: "ADD",
        roles: [],
        userIds: []
      },
      formRules: {
        mode: [{ required: true, message: "请选择设置类型", trigger: "blur" }],
        userIds: [
          { required: true, message: "用户不能为空", trigger: "change" }
        ],
        roles: [
          { required: true, message: "用户角色不能为空", trigger: "change" }
        ]
      },
      rolesOptions: [],
      userOptions: [],
      page: 0,
      size: 20,
      totalSizes: 0
    };
  },
  created() {
    this.getRolesOptions();
    this.getUserOptions();
  },
  watch: {
    userName() {
      this.getUserOptions();
    }
  },
  methods: {
    handleCurrentChange(val) {
      this.page = val - 1;
      this.getUserOptions();
    },
    getUserOptions() {
      this.$api
        .get(`/users`, {
          params: {
            page: this.page,
            size: this.size,
            name: this.userName
          }
        })
        .then(res => {
          if (res.status === 200 || res.status === 206) {
            this.userOptions = res.data.content;
            this.totalSizes = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    getRolesOptions() {
      this.$api
        .get(`/users/roles/selections`)
        .then(res => {
          if (res.status === 200) {
            this.rolesOptions = res.data;
          }
        })
        .catch(err => {
          console.log(err.response);
          this.$message.error(err.response.data.message);
        });
    },
    onSubmit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submiting = true;
          this.$api
            .put(`/users/roles?mode=${this.userForm.mode}`, {
              ids: this.userForm.userIds,
              roles: this.userForm.roles
            })
            .then(res => {
              if (res.status === 201 || res.status === 204) {
                this.submiting = false;
                this.$emit("onSuccess");
                this.$message.success("提交成功");
              }
            })
            .catch(err => {
              this.submiting = false;
              console.log(err.response);
              this.$message.error(err.response.data.message);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.user-edit-wrapper {
  box-sizing: border-box;
  width: 100%;
  text-align: left;
  padding: 15px;
  /deep/ {
   .el-pager li{
     background: none;
   }
   .btn-next, .btn-prev{
     background-color: transparent;
   }
  }
  .form-input {
    width: 100%;
  }
  .is-id-exist {
    right: 0;
    height: 16px;
    line-height: 16px;
    font-size: 12px;
    color: #f56c6c;
    text-align: right;
    overflow: hidden;
  }
  .user-control {
    box-sizing: border-box;
    height: 40px;
    margin-bottom: 20px;
    border-bottom: 3px solid #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .checkbox{
    box-sizing: border-box;
    padding: 0 10px;
    min-width: 150px;
  }
}
</style>